import { useEffect, useMemo, useState } from 'react';
import { createPaymentUser, getPaymentUserByOrg } from 'src/api/payment-user';
import { useOrganizationContext } from 'src/hooks/use-organization-context';
import { PaymentUser } from 'src/models/payment-user';
import { PaymentUserContext } from './payment-user-context-types';

interface PaymentUserProviderProps {
  children: React.ReactNode;
}

const PaymentUserProvider: React.FC<PaymentUserProviderProps> = ({ children }) => {
  const [paymentUser, setPaymentUser] = useState<PaymentUser>();
  const { currentOrg } = useOrganizationContext();

  useEffect(() => {
    if (currentOrg) {
      getPaymentUserByOrg(currentOrg).then((res) => {
        if (res.success) {
          if (res.data) {
            setPaymentUser(res.data ?? undefined);
          }
        }
      });
    }
  }, [currentOrg]);

  const providerValue = useMemo(() => {
    const addPaymentUser = (data: PaymentUser) => {
      createPaymentUser(data).then((res) => {
        if (res.success) {
          setPaymentUser(res.data ?? undefined);
        }
      });
    };

    return { paymentUser, addPaymentUser };
  }, [paymentUser]);

  return (
    <PaymentUserContext.Provider value={providerValue}>{children}</PaymentUserContext.Provider>
  );
};

export default PaymentUserProvider;
